import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import PendingRequestsDataGrid from 'src/components/PendingRequestsDataGrid/PendingRequestsDataGrid'
import { VirtualCardListModel } from 'src/models/virtualCard.models'
import {
  selectCardApprovalsEnabled,
  selectCardApprovalsFromState,
} from 'src/redux/selectors/data/organizations.selectors'

interface PendingRequestsTableProps {
  virtualCards: VirtualCardListModel[]
}

const PendingRequestsTable: React.FC<PendingRequestsTableProps> = (props) => {
  const isEmpty = props.virtualCards.length === 0
  const cardApprovalsEnabled = useSelector(selectCardApprovalsEnabled)
  const cardApprovalRules = useSelector(selectCardApprovalsFromState)

  const [clientHeight, setClientHeight] = useState<number | null>(null)
  const ref: React.MutableRefObject<HTMLDivElement | null> = useRef(null)

  const [viewportHeight, setViewportHeight] = useState({
    height: window.innerHeight,
  })

  const updateWindowSize = (): void => {
    setViewportHeight({ height: window.innerHeight })
  }

  useEffect(() => {
    setClientHeight(viewportHeight.height - 110)
  }, [ref?.current])

  useEffect(() => {
    window.addEventListener('resize', updateWindowSize)
    setClientHeight(viewportHeight.height - 110)
    return (): void => {
      window.removeEventListener('resize', updateWindowSize)
    }
  }, [viewportHeight, ref?.current])

  return (
    <div>
      {!isEmpty && (
        <PendingRequestsDataGrid
          virtualCards={props.virtualCards}
          cardApprovalRuleEnabled={cardApprovalsEnabled}
          cardApprovalRules={cardApprovalRules}
          clientHeight={clientHeight || 0}
        />
      )}
    </div>
  )
}

export default PendingRequestsTable
